import React, { useEffect } from 'react'
import { brandCSS } from '../../brand'
import { CONTACT_CSS } from './contact.css.js'
import Hero from './Hero'
import ContactInfo from './ContactInfo'
import ContactForm from './ContactForm'
import OfficeHours from './OfficeHours'

export default function ContactPage({ data }) {
  useEffect(() => {
    const root = document.getElementById('app-root')
    if (root) root.style.visibility = 'visible'
  }, [])
  
  const info     = data?.contact      ?? {}
  const mapUrl   = info.map_embed     ?? null
  const formHtml = info.form_html     ?? null
  const thumb    = data?.post?.thumb  ?? null

  return (
    <>
      <style>{brandCSS + CONTACT_CSS}</style>
      <div className="cp-page">

        <Hero thumb={thumb} />

        <div className="cp-main">
          <div className="cp-body">
            <ContactInfo info={info} mapUrl={mapUrl} />
            <ContactForm formHtml={formHtml} />
          </div>
          <OfficeHours />
        </div>

      </div>
    </>
  )
}
